import { Component } from '@angular/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

@Component({
  selector: 'app-document-file-preview-modal',
  templateUrl: './document-file-preview-modal.component.html',
  styleUrl: './document-file-preview-modal.component.scss',
  standalone: true,
  imports: [NgxExtendedPdfViewerModule, RktIconComponent],
})
export class DocumentFilePreviewModalComponent {
  type = '';
  url = '';
  name = '';
  fileFormat!: string;

  constructor(public activeModal: ActiveModal) {}

  modalInitData({ type, url, name, fileFormat }: { url: string; type: string; name: string; fileFormat: string }) {
    this.type = type;
    this.url = url;
    this.name = name;
    this.fileFormat = fileFormat;
  }
}
